import { useAuth } from "@/contexts/AuthContext";
import AdminDashboard from "@/pages/dashboards/AdminDashboard";
import ManagerDashboard from "@/pages/dashboards/ManagerDashboard";
import SalespersonDashboard from "@/pages/dashboards/SalespersonDashboard";

/**
 * Home dispatcher — routes by role so each persona sees an action-oriented view
 * tuned to what they actually do on a Monday morning.
 *   admin → AdminDashboard    (everything + system levers)
 *   manager → ManagerDashboard (team pulse, leaderboard, team follow-ups)
 *   else (salesperson/service/marketing/viewer) → SalespersonDashboard
 */
export default function Home() {
  const { user } = useAuth();
  const role = user?.role || "salesperson";
  if (role === "admin") return <AdminDashboard />;
  if (role === "manager") return <ManagerDashboard />;
  return <SalespersonDashboard />;
}
